// extracted by mini-css-extract-plugin
export var menuIcon = "_r3-0";
export var menuIconInline = "_r3-1";